<template>
  <div id="invitation">
    <van-row>
      <van-col span="22" offset="1">
        <van-col span="24" class="invitation_top_img">
          <img src="./../assets/img/banner_invite.png" v-if="is_banner_invite_img"/>
          <img src="./../assets/img/banner_invite2.png" v-else/>
        </van-col>
        <van-col span="24" class="invitation_money">
          <van-col span="11">
            <van-col span="24" class="invitation_money_name">{{ $t('column.total_invitation_revenue')}}</van-col>
            <van-col span="24" class="invitation_money_val">{{ user.coin }}</van-col>
         <!--   <van-col span="18" offset="3" class="invitation_money_btn" @click="withdrawal_btn()">提现</van-col>-->
          </van-col>
          <van-col span="2" class="invitation_money_bor">
            <img src="./../assets/img/invite_fngex.png"/>
          </van-col>
          <van-col span="11">
            <van-col span="24" class="invitation_money_name">{{ $t('column.total_number_people_invited')}}</van-col>
            <van-col span="24" class="invitation_money_val">{{ user.number }}</van-col>
            <van-col span="18" offset="3" class="invitation_money_btn" @click="invite_friends()">{{ $t('btn.invite_friends')}}</van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="invitation_bg_color"></van-col>
      <van-col span="24" class="invitation_type_bor" v-if="user.superior">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/upper_level.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name" @click="invite_superior()">{{ $t('column.my_superior')}}</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>
      <van-col span="24" class="invitation_type_bor">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/one_level.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name" @click="invite_team(1)">{{ $t('column.my_first_level_team') }}</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>
      <van-col span="24" class="invitation_type_bor" v-if="user.is_invitation_two">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/second_level.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name" @click="invite_team(2)">{{ $t('column.my_secondary_team')}}</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>
      <van-col span="24" class="invitation_type_bor" v-if="user.is_invitation_three">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/level_three.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name" @click="invite_team(3)">{{ $t('column.my_level_3_team')}}</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>
     <!-- <van-col span="24" class="invitation_type_bor">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/tix.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name"  @click="invite_withdrawal()">提现记录</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>-->
      <van-col span="24" class="invitation_type_bor">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/tix.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name"  @click="invite_earnings()">{{ $t('column.revenue_records')}}</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>
      <van-col span="24" class="invitation_type_bor" @click="Invite_rules()">
        <van-col span="4" class="invitation_type_img">
          <img src="./../assets/img/yaoqingguiz.png"/>
        </van-col>
        <van-col span="18" class="invitation_type_name">{{ $t('column.invitation_rules')}}</van-col>
        <van-col span="2" class="invitation_type_icon"><van-icon name="arrow" /></van-col>
      </van-col>
      <van-col span="24" class="iphonex_bottom"></van-col>
    </van-row>
    <van-popup v-model="show" position="bottom" :style="{ height: '70%' }"  closeable >
      <van-col span="22" offset="1" v-html='rules.title' class="invitation_rules_title"></van-col>
      <van-col span="22" offset="1" v-html='rules.content'></van-col>
    </van-popup>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Dialog } from 'vant'
  export default {
    data() {
      return {
        user: {},
        is_banner_invite_img: false,
        show: false,
        rules: {}
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.invitation')
    },
    components: {
      [Dialog.name]: Dialog
    },
    methods: {
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=index", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.user = res.data.data
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
        })
      },
      invite_friends () {
        // 邀请好友
        window.location.href="live://live?action=copy_share_url&copy=" + this.user.url;
      },
      Invite_rules () {
        // 邀请规则
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=reward_rules", {
          params : {
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.rules = res.data.data
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          } else {
            this.show = true
          }
        })
      },
      invite_team (type) {
        // 我的团队
        const token = this.$route.query.token
        this.$router.push({path:'/invitationSubordinate',query:{token: token, type:type }});
      },
      invite_withdrawal () {
        // 提现记录
        const token = this.$route.query.token
        this.$router.push({path:'/invitationRecord',query:{token: token }});
      },
      invite_earnings () {
        // 收益记录
        const token = this.$route.query.token
        this.$router.push({path:'/invitationEarnings',query:{token: token }});
      },
      withdrawal_btn () {
        // 提现
        const token = this.$route.query.token
        this.$router.push({path:'/invitationWithdrawal',query:{token: token }});
      },
      invite_superior () {
        // 我的上级
        const token = this.$route.query.token
        this.$router.push({path:'/invitationSuperior',query:{token: token }});
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invitation.vue